import { benefitsHeroBanner } from "@/assets/images";
import { approvedHeroBanner2V2 } from "@/assets/images";
import { Button, ButtonType } from "@/components/common/button";
import { useIsABTest } from "@/hooks/useIsABTest";
import { QuizQuestionProps } from "@/pages/quiz/context/types";

const ApprovedByDoctorQuestion = ({
  setQuestionAnswer,
}: QuizQuestionProps<boolean>) => {
  const { isABTest_6_Header } = useIsABTest();

  return (
    <>
      {
        !isABTest_6_Header && (
          <p className="section-title mb-4">
            Approved in minutes, shipped overnight.
          </p>
        )
      }
      <img src={isABTest_6_Header ? approvedHeroBanner2V2 : benefitsHeroBanner} alt="SkinnyRx benefits" />
      <Button onClick={() => setQuestionAnswer(true)} type={ButtonType.NEXT} />
    </>
  );
};

export { ApprovedByDoctorQuestion };
